<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item><router-link to="./">首页</router-link></el-breadcrumb-item>
      <el-breadcrumb-item>学生申请进度</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form inline label-width="70px" size="small" class="query-form" @submit.native.prevent="selClick">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="姓名/手机"></el-input>
        </el-form-item>
        <el-form-item label="期数">
          <el-select v-model="queryTemplateId" clearable placeholder="全部" style="width:140px">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="initClick">初始化进度</el-button>
          <el-button type="warning" @click="batchClick">批量一键处理</el-button>
          <el-button type="primary" plain @click="schoolUploadClick">按学校批量传文件</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>学生申请进度</span></div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          stripe
          @selection-change="onSelChange"
        >
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="stuName" label="学生" width="100"></el-table-column>
          <el-table-column prop="stuMobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="templateName" label="期数模板" width="100"></el-table-column>
          <el-table-column prop="applySchoolName" label="申请学校" min-width="120"></el-table-column>
          <el-table-column prop="currentStatus" label="当前节点" min-width="120"></el-table-column>
          <el-table-column label="进度" width="80">
            <template slot-scope="scope">{{ scope.row.progressPercent }}%</template>
          </el-table-column>
          <el-table-column label="小程序" width="90">
            <template slot-scope="scope">{{ scope.row.miniUserID ? '已关联' : '未关联' }}</template>
          </el-table-column>
          <el-table-column label="入学期" width="80">
            <template slot-scope="scope">{{ termName(scope.row.enrollTerm) }}</template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="160"></el-table-column>
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="detailClick(scope.row)">节点进度</el-button>
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              <el-button type="text" @click="bindClick(scope.row)">期数设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10,20,30,50]" :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 批量一键处理 -->
    <el-dialog title="批量一键处理" :visible.sync="batchVisible" width="560px">
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:14px"
        title="不分老师：可选「全部学生」推进该期某节点；也可只处理下方勾选的学生。"
      ></el-alert>
      <el-form :model="batchForm" label-width="100px" size="small">
        <el-form-item label="期数模板" required>
          <el-select v-model="batchForm.templateId" style="width:100%" @change="onBatchTplChange">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键节点" required>
          <el-select v-model="batchForm.stepId" style="width:100%" placeholder="请选择节点">
            <el-option
              v-for="item in batchStepList"
              :key="item.id"
              :label="(item.stepOrder || '') + ' · ' + item.stepName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标状态" required>
          <el-select v-model="batchForm.status" style="width:100%">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理范围">
          <el-radio-group v-model="batchForm.scope">
            <el-radio label="all">该模板全部学生</el-radio>
            <el-radio label="selected">仅列表勾选（{{ selectedRows.length }}人）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" @click="submitBatch">确认处理</el-button>
          <el-button @click="batchVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="初始化学生进度" :visible.sync="initVisible" width="560px">
      <el-form :model="initForm" ref="initForm" label-width="100px" @submit.native.prevent="submitInit">
        <div style="color:#909399;font-size:12px;margin:0 0 12px 100px">仅已签约（VIP）学生可开通申请进度</div>
        <el-form-item label="学生" prop="stuId" :rules="[{ required: true, message: '请选择学生' }]">
          <el-select
            v-model="initForm.stuId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入姓名/手机/微信号搜索"
            :remote-method="searchStudent"
            :loading="stuLoading"
            style="width:100%"
            @change="onStuChange"
          >
            <el-option
              v-for="item in stuList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="进度模板" prop="templateId" :rules="[{ required: true, message: '必选' }]">
          <el-select v-model="initForm.templateId" style="width:100%" placeholder="请选择">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请学校"><el-input v-model="initForm.applySchoolName"></el-input></el-form-item>
        <el-form-item label="申请专业"><el-input v-model="initForm.applyMajor"></el-input></el-form-item>
        <el-form-item label="出国日期">
          <el-date-picker v-model="initForm.abroadDate" type="date" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">初始化</el-button>
          <el-button @click="initVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="'进度详情 - ' + (detail.stuName || '')" :visible.sync="detailVisible" width="960px">
      <el-descriptions :column="2" border size="small" style="margin-bottom:16px">
        <el-descriptions-item label="模板">{{ detail.templateName }}</el-descriptions-item>
        <el-descriptions-item label="进度">{{ detail.progress && detail.progress.progressPercent }}%</el-descriptions-item>
        <el-descriptions-item label="学校">{{ detail.progress && detail.progress.applySchoolName }}</el-descriptions-item>
        <el-descriptions-item label="专业">{{ detail.progress && detail.progress.applyMajor }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="detail.records || []" border stripe size="small">
        <el-table-column prop="stepName" label="节点" min-width="120"></el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.status" size="mini" @change="saveRecord(scope.row)">
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="completedTime" label="完成时间" width="150"></el-table-column>
        <el-table-column label="备注" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" size="mini" @blur="saveRecord(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="学生附件" min-width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openRecordAttach(scope.row)">上传/管理</el-button>
            <span v-if="attachCount(scope.row.attachJson)" style="color:#909399;margin-left:4px">
              {{ attachCount(scope.row.attachJson) }}个
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="学生节点附件" :visible.sync="attachVisible" width="560px" append-to-body>
      <CaseFileUpload
        v-model="attachFiles"
        :upload-id="'progress-record-attach'"
        :active="attachVisible"
      />
      <div style="margin-top:16px;text-align:right">
        <el-button type="primary" :loading="submiting" @click="saveRecordAttach">保存附件</el-button>
        <el-button @click="attachVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑学生进度" :visible.sync="editVisible" width="520px">
      <el-form :model="editForm" ref="editForm" label-width="100px" @submit.native.prevent="submitEdit">
        <el-form-item label="申请学校"><el-input v-model="editForm.applySchoolName"></el-input></el-form-item>
        <el-form-item label="申请专业"><el-input v-model="editForm.applyMajor"></el-input></el-form-item>
        <el-form-item label="出国日期">
          <el-date-picker v-model="editForm.abroadDate" type="date" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="签证办理">
          <el-radio-group v-model="editForm.visaHandleType">
            <el-radio :label="0">小花办理</el-radio>
            <el-radio :label="1">自己办理</el-radio>
          </el-radio-group>
          <div style="color:#909399;font-size:12px;margin-top:4px">决定「签证办理」节点展示哪条话术</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
          <el-button @click="editVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 按学校批量上传 -->
    <el-dialog title="按学校批量传文件" :visible.sync="schoolUploadVisible" width="560px">
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:14px"
        title="将附件合并写入：指定模板 + 申请学校相同的学生，某一节点的「学生附件」。"
      ></el-alert>
      <el-form :model="schoolUploadForm" label-width="100px" size="small">
        <el-form-item label="期数模板" required>
          <el-select v-model="schoolUploadForm.templateId" style="width:100%" @change="onSchoolTplChange">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请学校" required>
          <el-select
            v-model="schoolUploadForm.schoolName"
            filterable
            allow-create
            default-first-option
            style="width:100%"
            placeholder="选择或输入学校名"
          >
            <el-option v-for="s in schoolNameList" :key="s" :label="s" :value="s"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键节点" required>
          <el-select v-model="schoolUploadForm.stepId" style="width:100%">
            <el-option
              v-for="item in schoolStepList"
              :key="item.id"
              :label="(item.stepOrder || '') + ' · ' + item.stepName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件" required>
          <CaseFileUpload
            v-model="schoolUploadFiles"
            :upload-id="'progress-school-batch'"
            :active="schoolUploadVisible"
            file-exts="jpg;jpeg;png;gif;bmp;webp;pdf;doc;docx;xls;xlsx;ppt;pptx;txt;zip;rar;7z;mp4;mov;m4v"
            btn-text="上传文件"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" @click="submitSchoolUpload">确认批量写入</el-button>
          <el-button @click="schoolUploadVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="入学期与进度模板" :visible.sync="bindVisible" width="480px">
      <el-form :model="bindForm" label-width="110px" @submit.native.prevent="submitBind">
        <el-form-item label="学生">
          <el-input :value="(bindForm.stuName || '') + ' #' + bindForm.stuId" disabled></el-input>
        </el-form-item>
        <el-form-item label="入学期">
          <el-select v-model="bindForm.enrollTerm" clearable style="width:100%">
            <el-option v-for="item in termList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="进度模板">
          <el-select v-model="bindForm.progressTemplateID" clearable style="width:100%">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
          <el-button @click="bindVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import CaseFileUpload from "@/components/CaseFileUpload.vue";

export default {
  name: "studentProgress",
  components: { CaseFileUpload },
  data() {
    return {
      key: "",
      queryTemplateId: null,
      loading: false,
      tableData: [],
      selectedRows: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      templateList: [],
      termList: [],
      statusList: [],
      stuList: [],
      stuLoading: false,
      initVisible: false,
      initForm: {},
      detailVisible: false,
      detail: {},
      bindVisible: false,
      bindForm: {},
      editVisible: false,
      editForm: {},
      batchVisible: false,
      batchForm: { templateId: null, stepId: null, status: 2, scope: "all" },
      batchStepList: [],
      attachVisible: false,
      attachFiles: [],
      attachRow: null,
      schoolUploadVisible: false,
      schoolUploadForm: { templateId: null, stepId: null, schoolName: "" },
      schoolUploadFiles: [],
      schoolStepList: [],
      schoolNameList: [],
      submiting: false
    };
  },
  created() {
    $.get(url.getProgress("GetList_TemplateSel"), {}, res => { this.templateList = res; });
    $.get(url.getProgress("GetSelList_EnrollTerm"), {}, res => { this.termList = res; });
    $.get(url.getProgress("GetSelList_StepStatus"), {}, res => { this.statusList = res; });
    this.getList();
  },
  methods: {
    api(a) { return url.getProgress(a); },
    termName(id) {
      const item = this.termList.find(x => x.id === id);
      return item ? item.name : "";
    },
    attachCount(json) {
      try {
        var arr = typeof json === "string" ? JSON.parse(json || "[]") : (json || []);
        return Array.isArray(arr) ? arr.length : 0;
      } catch (e) { return 0; }
    },
    parseAttach(json) {
      try {
        var arr = typeof json === "string" ? JSON.parse(json || "[]") : (json || []);
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.getList(); },
    handleCurrentChange(val) { this.currentPage = val; this.getList(); },
    selClick() { this.currentPage = 1; this.getList(); },
    onSelChange(rows) { this.selectedRows = rows || []; },
    getList() {
      this.loading = true;
      $.get(this.api("GetList_StudentProgress"), {
        key: this.key,
        templateId: this.queryTemplateId || 0,
        pageindex: this.currentPage,
        pagesize: this.pageSize
      }, data => {
        this.loading = false;
        this.tableData = data.list;
        this.total = data.total;
      });
    },
    searchStudent(key) {
      if (!key) {
        this.stuList = [];
        return;
      }
      this.stuLoading = true;
      $.get(this.api("Search_Student"), { key: key }, res => {
        this.stuLoading = false;
        this.stuList = res || [];
      });
    },
    onStuChange(id) {
      const item = this.stuList.find(x => x.id === id);
      if (!item) return;
      this.$set(this.initForm, "applySchoolName", item.applySchool || this.initForm.applySchoolName);
      if (item.abroadDate) this.$set(this.initForm, "abroadDate", item.abroadDate);
      if (item.progressTemplateID) {
        this.$set(this.initForm, "templateId", item.progressTemplateID);
      } else if (item.enrollTerm) {
        const tpl = this.templateList.find(x => x.termCode === item.enrollTerm);
        if (tpl) this.$set(this.initForm, "templateId", tpl.id);
      }
    },
    batchClick() {
      this.batchForm = {
        templateId: this.queryTemplateId || (this.templateList[0] && this.templateList[0].id) || null,
        stepId: null,
        status: 2,
        scope: this.selectedRows.length ? "selected" : "all"
      };
      this.batchStepList = [];
      this.batchVisible = true;
      if (this.batchForm.templateId) this.onBatchTplChange(this.batchForm.templateId);
    },
    onBatchTplChange(tplId) {
      this.batchForm.stepId = null;
      this.batchStepList = [];
      if (!tplId) return;
      $.get(this.api("GetList_Step"), { templateId: tplId }, res => {
        this.batchStepList = res || [];
      });
    },
    submitBatch() {
      if (!this.batchForm.templateId || !this.batchForm.stepId) {
        this.$message.warning("请选择模板和节点");
        return;
      }
      var stuIds = "";
      if (this.batchForm.scope === "selected") {
        if (!this.selectedRows.length) {
          this.$message.warning("请先在列表勾选学生，或改选「全部学生」");
          return;
        }
        stuIds = this.selectedRows.map(r => r.stuID).join(",");
      }
      var tip = this.batchForm.scope === "all"
        ? "确认推进该模板下全部学生的该节点？"
        : "确认推进已勾选的 " + this.selectedRows.length + " 名学生？";
      this.$confirm(tip, "批量处理", { type: "warning" }).then(() => {
        this.submiting = true;
        $.post(this.api("BatchAdvance_Step"), {
          templateId: this.batchForm.templateId,
          stepId: this.batchForm.stepId,
          status: this.batchForm.status,
          stuIds: stuIds
        }, res => {
          this.submiting = false;
          if (res.status) {
            this.batchVisible = false;
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      }).catch(() => {});
    },
    initClick() {
      this.initForm = { stuId: null, templateId: null, applySchoolName: "", applyMajor: "", abroadDate: null };
      this.stuList = [];
      this.initVisible = true;
    },
    submitInit() {
      this.$refs.initForm.validate(valid => {
        if (!valid) return;
        this.submiting = true;
        $.post(this.api("Init_StudentProgress"), this.initForm, res => {
          this.submiting = false;
          if (res.status) { this.initVisible = false; this.getList(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      });
    },
    detailClick(row) {
      $.get(this.api("GetModel_StudentProgress"), { id: row.id }, res => {
        this.detail = res;
        this.detailVisible = true;
      });
    },
    saveRecord(row) {
      var _this = this;
      $.post(this.api("Update_StepRecord"), {
        id: row.id,
        status: row.status,
        remark: row.remark,
        attachJson: row.attachJson,
        completedTime: row.completedTime
      }, res => {
        if (res.status) {
          var pid = _this.detail.progress && _this.detail.progress.id;
          if (pid) _this.detailClick({ id: pid });
          _this.getList();
        } else _this.$message.error(res.msg);
      });
    },
    openRecordAttach(row) {
      this.attachRow = row;
      this.attachFiles = this.parseAttach(row.attachJson);
      this.attachVisible = true;
    },
    saveRecordAttach() {
      if (!this.attachRow) return;
      this.attachRow.attachJson = JSON.stringify(this.attachFiles || []);
      this.submiting = true;
      var _this = this;
      $.post(this.api("Update_StepRecord"), {
        id: this.attachRow.id,
        status: this.attachRow.status,
        remark: this.attachRow.remark,
        attachJson: this.attachRow.attachJson,
        completedTime: this.attachRow.completedTime
      }, res => {
        _this.submiting = false;
        if (res.status) {
          _this.attachVisible = false;
          var pid = _this.detail.progress && _this.detail.progress.id;
          if (pid) _this.detailClick({ id: pid });
          _this.$message.success("附件已保存");
        } else _this.$message.error(res.msg);
      });
    },
    bindClick(row) {
      this.bindForm = {
        stuId: row.stuID,
        stuName: row.stuName,
        enrollTerm: row.enrollTerm,
        progressTemplateID: row.progressTemplateID || row.templateID
      };
      this.bindVisible = true;
    },
    editClick(row) {
      this.editForm = {
        id: row.id,
        applySchoolName: row.applySchoolName,
        applyMajor: row.applyMajor,
        abroadDate: row.abroadDate,
        visaHandleType: row.visaHandleType == null ? 0 : row.visaHandleType
      };
      this.editVisible = true;
    },
    schoolUploadClick() {
      this.schoolUploadForm = {
        templateId: this.queryTemplateId || (this.templateList[0] && this.templateList[0].id) || null,
        stepId: null,
        schoolName: ""
      };
      this.schoolUploadFiles = [];
      this.schoolStepList = [];
      this.schoolNameList = [];
      this.schoolUploadVisible = true;
      if (this.schoolUploadForm.templateId) this.onSchoolTplChange(this.schoolUploadForm.templateId);
    },
    onSchoolTplChange(tplId) {
      this.schoolUploadForm.stepId = null;
      this.schoolUploadForm.schoolName = "";
      this.schoolStepList = [];
      this.schoolNameList = [];
      if (!tplId) return;
      $.get(this.api("GetList_Step"), { templateId: tplId }, res => {
        this.schoolStepList = res || [];
      });
      $.get(this.api("GetSchoolList_Progress"), { templateId: tplId }, res => {
        this.schoolNameList = res || [];
      });
    },
    submitSchoolUpload() {
      if (!this.schoolUploadForm.templateId || !this.schoolUploadForm.stepId || !this.schoolUploadForm.schoolName) {
        this.$message.warning("请填写模板、学校、节点");
        return;
      }
      if (!this.schoolUploadFiles.length) {
        this.$message.warning("请先上传附件");
        return;
      }
      this.submiting = true;
      $.post(this.api("BatchUpload_AttachBySchool"), {
        templateId: this.schoolUploadForm.templateId,
        stepId: this.schoolUploadForm.stepId,
        schoolName: this.schoolUploadForm.schoolName,
        attachJson: JSON.stringify(this.schoolUploadFiles)
      }, res => {
        this.submiting = false;
        if (res.status) {
          this.schoolUploadVisible = false;
          this.$message.success(res.msg);
        } else this.$message.error(res.msg);
      });
    },
    submitEdit() {
      this.submiting = true;
      $.post(this.api("Save_StudentProgress"), this.editForm, res => {
        this.submiting = false;
        if (res.status) { this.editVisible = false; this.getList(); this.$message.success(res.msg); }
        else this.$message.error(res.msg);
      });
    },
    submitBind() {
      this.submiting = true;
      $.post(this.api("Save_MiniBind"), {
        stuId: this.bindForm.stuId,
        enrollTerm: this.bindForm.enrollTerm,
        progressTemplateID: this.bindForm.progressTemplateID
      }, res => {
        this.submiting = false;
        if (res.status) { this.bindVisible = false; this.getList(); this.$message.success(res.msg); }
        else this.$message.error(res.msg);
      });
    }
  }
};
</script>

<style scoped>
.query-form { margin-top: 20px; padding-top: 25px; background: #f2f2f2; }
</style>
